import React from "react";

import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from "@mui/material";
import SubCard from "components/common/card/SubCard";
import HeadComponent from "../list/list-head/Head.component";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const CameraTable = ({ item }) => {
  const { t } = useTranslation()
  const theme = useTheme();

  const TABLE_HEAD = useMemo(() => (
    [
      { id: "camera", label: "Camera", alignRight: false, order: true },
      { id: "cameraAddress", label: t('Address'), alignRight: false, order: true },

    ]
  ), [t])

  return (
    <TableContainer>
      <SubCard
        sx={{
          bgcolor: theme.palette.mode === "dark" ? "dark.800" : "grey.50",
          mb: 2,
        }}
        content={false}
      >
        <Table size="small" aria-label="purchases">
          <HeadComponent header={TABLE_HEAD} sx={{ fontSize: 12 }} />

          <TableBody>
            <TableRow sx={{
              '&:last-child td, &:last-child th': {
                border: 0,
              }
            }}>
              <TableCell align="left">
                {item?.camera ? (
                  <Chip
                    label={t('Present')}
                    size='small'
                    sx={{
                      backgroundColor: "#B9F6CA",
                      color: "#00C853",
                    }}
                  />
                ) : (
                  <Chip label={t('absent')} size='small' />
                )}
              </TableCell>

              {!!item?.cameraAddress && (
                <TableCell align="left">{item?.cameraAddress}</TableCell>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </SubCard>
    </TableContainer>
  );
};

export default CameraTable;


